/**
 * useResponsiveLayout: detects whether the current viewport should use
 * the desktop layout (fixed side panels) or the tablet/touch layout
 * (bottom sheet inspector, simplified library). PRD §14.4, §1's design
 * philosophy: "feels guided... tablet-first for the coordinator's
 * in-venue use."
 *
 * Breakpoint chosen at 1024px — below this, even a physically large
 * tablet in portrait doesn't have room for two fixed side panels plus a
 * usable canvas.
 */

import { useEffect, useState } from 'react';

const BREAKPOINT_PX = 1024;

export type LayoutMode = 'desktop' | 'compact';

export function useResponsiveLayout(): LayoutMode {
  const [mode, setMode] = useState<LayoutMode>(() =>
    typeof window !== 'undefined' && window.innerWidth >= BREAKPOINT_PX ? 'desktop' : 'compact'
  );

  useEffect(() => {
    function handleResize() {
      setMode(window.innerWidth >= BREAKPOINT_PX ? 'desktop' : 'compact');
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return mode;
}
